import { useState } from "react";
import { downloadBlob } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { FileDown, Loader2 } from "lucide-react";
import { toast } from "sonner";

export function MonthlyReportButton() {
  const [month, setMonth] = useState(new Date().toISOString().slice(0, 7));
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      await downloadBlob("/reports/monthly", `LendingPH-Report-${month}.pdf`, { month });
      toast.success("Report downloaded");
    } catch {
      toast.error("Could not generate report");
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="flex items-center gap-2" data-testid="monthly-report-control">
      <Input type="month" value={month} onChange={(e) => setMonth(e.target.value)} data-testid="report-month-input"
        className="w-40 h-10 bg-black/30 border-white/10 text-white [color-scheme:dark]" />
      <Button onClick={run} disabled={busy || !month} data-testid="download-report-button" className="bg-emerald-600 hover:bg-emerald-500 text-white">
        {busy ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : <FileDown className="h-4 w-4 mr-2" />} Monthly PDF
      </Button>
    </div>
  );
}
